var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-search"},[_c('svg-loader',{attrs:{"src":"/static/images/exams.svg"}}),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.subtitle))])]),_vm._v(" "),_c('fast-search')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }